
var screenDesktop = window.matchMedia('screen and (min-width: 990px)');
var screenTablet = window.matchMedia('screen and (min-width: 641px) and (max-width: 989px)');
var screenMobile = window.matchMedia('screen and (max-width: 640px)');
var screenTabletMobile = window.matchMedia('screen and (max-width: 989px)');

var footerMenuCollapsible = [...document.querySelectorAll('.footer-menu-collapsible')];
footerMenuCollapsible.forEach((eL, idx) => {
  eL.addEventListener('click', (e) => {
    if (screenTabletMobile.matches) {
      if(e.target.classList.contains('link--first-level')) {
        e.preventDefault();
        e.target.closest('.footer-menu-collapsible').classList.toggle('active');
      }
    } else {
      if(e.target.classList.contains('link--first-level')) e.preventDefault();
    }
    
  });
});

function initializeLogoAnimation() {
  if(pageType == "index") {
    var headerHeadingLogo = document.querySelector('.header__heading-logo');
    var imageToAnimate = document.querySelector("#image-animate");
    if (!imageToAnimate) return;
    var imageToAnimateWidth = imageToAnimate.clientWidth;
    
    var desktopSpeed = 1.6;
    var tabletSpeed = 1.3;
    var mobileSpeed = 1.7;
    
    var desktopTop = 400;
    var tabletTop = 360;
    var mobileTop = 225;
    
    var browserScrollTop = 0;
    var scrollAndSpeed = 0;
    
    function animateLogo() {
      var scrolltop = window.pageYOffset;
      
      if (screenDesktop.matches) {
        browserScrollTop = desktopTop;
        scrollAndSpeed =  imageToAnimateWidth - scrolltop / desktopSpeed;
      } else if (screenTablet.matches) {
        browserScrollTop = tabletTop;
        scrollAndSpeed =  imageToAnimateWidth - scrolltop / tabletSpeed;
      } else {
        browserScrollTop = mobileTop;
        scrollAndSpeed =  imageToAnimateWidth - scrolltop / mobileSpeed;
      }
    
      imageToAnimate.style.width = scrollAndSpeed + "px";
    
      if(scrolltop > browserScrollTop) {
        imageToAnimate && (imageToAnimate.style.opacity = 0);
        headerHeadingLogo && (headerHeadingLogo.style.opacity = 1);
      } else {
        imageToAnimate && (imageToAnimate.style.opacity = 1);
        headerHeadingLogo && (headerHeadingLogo.style.opacity = 0);
      }
    }
    
    window.addEventListener('scroll', function() {
      requestAnimationFrame(animateLogo);
    }, false);
  }
}

initializeLogoAnimation();

var collectionListItem = document.querySelectorAll('[data-collection-link]');
collectionListItem.forEach((eL, idx) => {
  eL.addEventListener('click', (e) => {
    location.href = e.target.closest('li').dataset.collectionLink;
  });
});

function showbackstock(arg,div) {
	$("#Backstock_block").slideToggle(500);
 
}
function showcartoff(arg,div) {
	$("#cartoff").slideToggle(500);
}